import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { deferredPrompt } from '../../../main';
import {
    AMPLITUDE_EVENT_CATEGORIES,
    AMPLITUDE_EVENTS,
    AmplitudeService,
} from '../../global-services/amplitude.service';
import { AuthService } from '../../global-services/auth.service';
import { INSTALL_CTA_SOURCE } from '../../shared/utils';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'pwa-install-nudge',
    templateUrl: './pwa-install-nudge.component.html',
    styleUrl: './pwa-install-nudge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PwaInstallNudgeComponent implements OnInit, OnDestroy {
    isIOS: boolean = false;
    isIosPromptDrawerOpen: boolean = false;
    isPwaInstalled: boolean = false;
    deviceOs: string;

    ngUnsubscribe: Subject<any> = new Subject();

    constructor(
        private authService: AuthService,
        private deviceDetectorService: DeviceDetectorService,
        private amplitude: AmplitudeService
    ) {}

    ngOnInit() {
        this.deviceOs = this.deviceDetectorService.getDeviceInfo().os;
        this.checkPlatform();

        window.addEventListener('appinstalled', () => {
            this.isPwaInstalled = true; // Hide the nudge after installation
            this.amplitude.logEvent(
                AMPLITUDE_EVENT_CATEGORIES.Engagement,
                AMPLITUDE_EVENTS.MYCARDS_INSTALLED,
                {
                    device: this.deviceOs,
                    source: INSTALL_CTA_SOURCE.MYCARDS_HOME_PAGE,
                }
            );
        });

        this.authService.isOpenedAsPWA$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((isPwaInstalled) => {
                this.isPwaInstalled = isPwaInstalled;
            });
    }

    checkPlatform() {
        const isMobile = this.deviceDetectorService.isMobile();

        console.log(this.deviceOs, 'deviceOs');

        if (isMobile && this.deviceOs !== 'iOS') {
            this.isIOS = false;
        } else if (isMobile && this.deviceOs === 'iOS') {
            this.isIOS = true;
        }
    }

    promptInstall() {
        this.amplitude.logEvent(
            AMPLITUDE_EVENT_CATEGORIES.Engagement,
            AMPLITUDE_EVENTS.MYCARDS_INSTALL_LINK_CLICKED,
            {
                device: this.deviceOs,
                source: INSTALL_CTA_SOURCE.MYCARDS_HOME_PAGE,
            }
        );
        if (this.isIOS) {
            this.isIosPromptDrawerOpen = true;
            this.logInstallPromptOpenEventForAmplitude();
        } else if (deferredPrompt && !this.isIOS) {
            this.isIosPromptDrawerOpen = false;
            deferredPrompt.prompt();
            this.logInstallPromptOpenEventForAmplitude();
            deferredPrompt.userChoice.then((result: any) => {
                if (result.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
            });
        }
    }

    logInstallPromptOpenEventForAmplitude() {
        this.amplitude.logEvent(
            AMPLITUDE_EVENT_CATEGORIES.Engagement,
            AMPLITUDE_EVENTS.MYCARDS_INSTALL_MODAL_OPENED,
            {
                device: this.deviceOs,
                source: INSTALL_CTA_SOURCE.MYCARDS_HOME_PAGE,
            }
        );
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }

    protected readonly deferredPrompt = deferredPrompt;
}
